export default {
  viewDocument: {
    en: 'View document',
    jp: 'ドキュメントを表示',
  },
  yes: {
    en: 'Yes',
    jp: 'はい',
  },
  no: {
    en: 'No',
    jp: 'いいえ',
  },
  previewBeforeSubmitting: {
    en: '',
    jp: '提出前にプレビューし',
  },
  finalReview: {
    en: '',
    jp: 'ドキュメントを表示',
  },
  checkThisBox1: {
    en: '',
    jp: '電子規約と署名の使用に同意するには',
  },
  checkThisBox2: {
    en: '',
    jp: '、このボックスにチェックを入れてください。',
  },
  submit: {
    en: 'Submit',
    jp: '提出する',
  },
  attach: {
    en: 'Attach',
    jp: 'アップロード',
  },
  completed: {
    en: '',
    jp: '完成しました！',
  },
  openInHarbour: {
    en: 'Open in Harbour',
    jp: 'で開く Harbour',
  },
  thanksForCompleting: {
    en: '',
    jp: '書類を完成させていただきありがとうございます。完全に実行されたコピーが送信されました。',
  },
  emailCopySentTo: {
    en: 'Email copy sent to',
    jp: 'コピーを電子メールで送信しました',
  },
};
